import { Paper, Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import emptySportsImage from '../images/empty-sports.svg';

type SttNoResultsProps = {
    text?: string;
    paper?: boolean;
};

export function SttNoResults({ text, paper = false }: SttNoResultsProps) {
    const { t } = useTranslation();

    const content = (
        <Grid container>
            <Grid size={{ xs: 12 }}>
                <Box display="flex" justifyContent="center" py={3}>
                    <img
                        src={emptySportsImage}
                        width={120}
                        height={120}
                        alt={t('ui.noResults')}
                        style={{ opacity: 0.7 }}
                    />
                </Box>
            </Grid>

            <Grid size={{ xs: 12 }}>
                <Typography
                    align="center"
                    color="text.secondary"
                    sx={{ fontWeight: 500 }}
                >
                    {text || t('ui.noResults')}
                </Typography>
            </Grid>
        </Grid>
    );

    if (paper) {
        return <Paper sx={{ py: 4 }}>{content}</Paper>;
    }

    return content;
}
